var map = {
	"./AMPAY.png": 609,
	"./ANYPAY.png": 610,
	"./BAAC.png": 611,
	"./BAY.png": 612,
	"./BBL.png": 613,
	"./BITPAYz.png": 614,
	"./CIMB.png": 615,
	"./CLICX.png": 616,
	"./GHBANK.png": 617,
	"./GM2PAY.png": 618,
	"./GSB.png": 619,
	"./HYRONPAY.png": 620,
	"./IBANK.png": 621,
	"./KBANK.png": 622,
	"./KK.png": 623,
	"./KTB.png": 624,
	"./LHBANK.png": 625,
	"./MXSOUL.png": 626,
	"./NONE.png": 341,
	"./P2PAY.png": 627,
	"./SCB.png": 628,
	"./SECUREPAY.png": 629,
	"./THUNDERPAY.png": 630,
	"./TRUEWALLET.png": 631,
	"./TTB.png": 632,
	"./TWOSTEPX.png": 633,
	"./UOB.png": 634,
	"./logo-bank-0.png": 635,
	"./logo-bank-1.png": 636,
	"./logo-bank-10.png": 637,
	"./logo-bank-11.png": 638,
	"./logo-bank-12.png": 639,
	"./logo-bank-13.png": 640,
	"./logo-bank-14.png": 641,
	"./logo-bank-2.png": 642,
	"./logo-bank-3.png": 643,
	"./logo-bank-4.png": 644,
	"./logo-bank-5.png": 645,
	"./logo-bank-6.png": 646,
	"./logo-bank-7.png": 647,
	"./logo-bank-8.png": 648,
	"./logo-bank-9.png": 649
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 608;